module.exports = __webpack_public_path__ + "static/img/banner2.80f96671.jpeg";